// Library Methods
import { useTranslation } from "react-i18next";
import React from "react";

// Components
import { Box, Divider, Grid, Typography } from "@mui/material";
import ExamCardButton from "../ui/ExamCardButton";
import ExamCardToggles from "../ui/ExamCardToggles";
import TitleWithTooltip from "../../../../../components/UI/TitleWithTooltip";
import ExamCardContainer from "../ui/ExamCardContainer";
import ExamCardHeader from "../ui/ExamCardHeader";

const RAPDCard = ({
  label,
  examAlgorithm,
  selectedExamCards,
  updateExamCardProperty,
  onToggleCard,
}) => {
  // internationalization
  const { t } = useTranslation();

  const defaultRAPD = {
    examFieldType: examAlgorithm,
    examType: "THRESHOLDING",
    eyeCheckboxes: { right: true, left: true },
    binocular: true,
    optionalToggles: {
      calibration: true,
      requiresTutorial: true,
    },
  };

  const selectedExamCard = selectedExamCards.find(
    (examCard) => examCard.examFieldType === examAlgorithm
  );
  const examCardInfo = selectedExamCard ?? defaultRAPD;
  const isActive = Boolean(selectedExamCard);

  const { optionalToggles } = examCardInfo;

  const textStyle = {
    color: isActive ? "#FFF" : "#5B6D7A",
    fontSize: "14px",
  };

  return (
    <ExamCardContainer isActive={isActive}>
      <ExamCardHeader
        label={label}
        isActive={isActive}
        onChange={(e) => {
          onToggleCard(e, defaultRAPD);
        }}
      />
      <Grid item container display="flex" flexDirection="column" gap="8px">
        {/* stereopsis */}
        <Grid item display="flex" flexDirection="column" gap="8px">
          <TitleWithTooltip
            title={t("word_method")}
            tooltip={t("method_tooltip")}
            titleStyle={textStyle}
            tooltipStyle={textStyle}
          />

          <Grid container item display="flex" gap="8px">
            <Grid item xs>
              <ExamCardButton
                isSelected
                updateValue={() =>
                  updateExamCardProperty("examType", "THRESHOLDING")
                }
                label={t("word_thresholding")}
                isDisabled={!isActive}
              />
            </Grid>
          </Grid>
        </Grid>

        <Box height={{ xs: "80px", sm: "495.5px" }} />

        <Divider color="#5B6D7A" />

        <Grid display="flex" flexDirection="column">
          <ExamCardToggles
            isActive={isActive}
            optionalToggles={optionalToggles}
            updateExamCardProperty={updateExamCardProperty}
            showToggles={defaultRAPD.optionalToggles}
          />
        </Grid>

        <Grid item textAlign="center">
          <Typography color={isActive ? "#FFF" : "#5B6D7A"} fontSize="14px">
            {t("new_test")}
          </Typography>
          <Typography color={isActive ? "#FFF" : "#5B6D7A"} fontSize="14px">
            {t("try_it_out")}
          </Typography>
        </Grid>
      </Grid>
    </ExamCardContainer>
  );
};

export default RAPDCard;
